module.exports = __webpack_public_path__ + "img/cadeau.1a0b128b.png";